
import { Component, Vue } from "vue-property-decorator";
import ServicesNav from "@/components/Main/Services/ServicesNav.vue";
import ServicesBanner from "@/components/Main/Services/ServicesBanner.vue"
// import PublicPromocode from "@/components/Main/Services/PublicPromocode.vue";
import ServiceOS from "@/components/Main/Services/ServiceOS.vue";
import DexMobileModal from "@/components/Main/Services/Modals/DexMobileModal.vue" 
@Component({
  components: {
    ServicesNav,
    ServicesBanner,
    // PublicPromocode,
    ServiceOS,
    DexMobileModal
  },
})
export default class DexCloud extends Vue {
  public isShowModal: boolean  = false;

  // methods
  public handleShowModal() {
    this.isShowModal = true
  }

  public handleCloseDexMobileModal() {
    this.isShowModal = false
  }
}
